import React, {Component} from 'react'
import {Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import Swal from "sweetalert2";
import {withTourGuide} from "../../../guideComponent/withTourGuide";

class EditFinanceTerm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      prosesSimpan: false
    }
    this.triggerGuideOnce = this.triggerGuideOnce.bind(this)
  }

  triggerGuideOnce = (e, config) => {
      const { showGuide, isGuideActive, disabledKeys } = this.props;

      const target = e?.currentTarget ?? null;
      if (!target || !config?.key) return;
      if (disabledKeys?.includes(config.key)) return;
      if (isGuideActive) return;
      showGuide(target, config);
  };

  handleEdit = () => {
    this.setState({ prosesSimpan: true})
    let form = {
      fin_term_id   : this.props.data.fin_term_id,
      fin_term_name : this.props.data.fin_term_name,
      fin_term_type : this.props.data.fin_term_type,
    }
    this.props.request("finance_term/edit", form, 'POST')
      .then((response) => {
        if (response.success) {
          this.props.changeState({
            modal_edit: false,
            data: [],
          }, () => this.props.loadData())
          Swal.fire({
            title: 'Berhasil!',
            text: response.message,
            icon: 'success',
            confirmButtonText: 'OK'
          })
        } else {
          Swal.fire({
            title: 'Gagal!',
            text: response.message,
            icon: 'warning',
            confirmButtonText: 'OK'
          })
        }
      })
  }

  render() {
    return (
      <Modal isOpen={this.props.modal_edit} toggle={() => this.props.changeState({ modal_edit: false })} style={{ maxWidth: "1000px"}} zIndex={999}>
        <ModalHeader className="pengumuman-modal-header" toggle={() => this.props.changeState({ modal_edit: false })}>
          <div className='presensi-modal-title'>Edit Istilah Keuangan</div>
        </ModalHeader>
        <ModalBody className="pengumuman-modal-body">
              <div className="row p-3">
                  <div className="col">
                      <div className="form-group">
                          <label className="pengumuman-label-input" htmlFor="exampleFormControlInput1">
                              Nama Istilah Keuangan
                          </label>
                          <input
                              className="form-control col-xl-12 col-md-12"
                              name="fin_term_name" value={this.props.data.fin_term_name}
                              placeholder="Masukkan nama istilah keuangan"
                              type="text" required=""
                              onChange={this.props.handleChange}
                              onPointerEnter={(e) => {
                                  this.triggerGuideOnce(e, {
                                      key: "editNamaIstilahKeuangan",
                                      title: "Nama Istilah Keuangan",
                                      content: "Ubah nama istilah keuangan sesuai kebutuhan, misalnya 'Gaji Pokok' atau 'Tunjangan Transport'."
                                  });
                              }}
                          />
                      </div>
                      <div className="form-group">
                          <label className="pengumuman-label-input" htmlFor="exampleFormControlInput1">
                              Tipe Istilah Keuangan
                          </label>
                          <select
                              className="form-control col-xl-12 col-md-12"
                              name="fin_term_type" value={this.props.data.fin_term_type}
                              onChange={this.props.handleChange}
                              onPointerEnter={(e) => {
                                  this.triggerGuideOnce(e, {
                                      key: "editTipeIstilahKeuangan",
                                      title: "Tipe Istilah Keuangan",
                                      content: "Ubah tipe istilah keuangan. Pilih 'Income' untuk pemasukan atau 'Outcome' untuk pengeluaran."
                                  });
                              }}
                          >
                              <option value="">Pilih Tipe</option>
                              <option value="income">income</option>
                              <option value="outcome">outcome</option>
                          </select>
                      </div>
                  </div>
              </div>
          </ModalBody>
        <ModalFooter className="pengumuman-modal-footer">
          <button
            onClick={() => this.props.changeState({modal_edit: false})}
            className='btn text-capitalize batalkan-add-jamker'>Batal
          </button>
          <button
            className='btn btn-primary text-capitalize' disabled={this.state.prosesSimpan}
            style={{padding: "8px 14px", fontWeight: 500, fontSize: "14px", lineHeight: "24px"}}
            onClick={this.handleEdit}>{this.state.prosesSimpan ? "Menyimpan" : "Simpan"}
          </button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default withTourGuide(EditFinanceTerm);